import { useEffect, useRef, useMemo, useCallback } from 'react';
import maplibregl from 'maplibre-gl';
import { createPortal } from 'react-dom';
import classnames from 'classnames';

import { HouseIcon } from '../icons/house';
import { shortPrice } from '../../helpers/short-price';

export function PropertyMarker({
  map,
  coords,
  bounds,
  isDetailed,
  items,

  fitBounds,
  highlight,
  highlighted,
}) {
  let markerNode = useMemo(() => document.createElement(`div`), []);
  let markerRef = useRef(markerNode);

  useEffect(() => {
    let marker = new maplibregl
      .Marker({ element: markerRef.current })
      .setLngLat([coords[1], coords[0]])
      .addTo(map);

    return () => marker.remove();
  }, []);

  let onClick = useCallback(() => {
    if (isDetailed) highlight(items);
    else fitBounds(bounds);
  }, [isDetailed]);

  let isHighlighted = useMemo(() => highlighted.some(x => x.id === items[0].id), [highlighted, items]);

  let iconClassName = useMemo(() => classnames(
    `map-search__marker`,
    items.length > 1 ? `map-search__marker_type_multiple` : `map-search__marker_type_single`,
    isHighlighted ? `map-search__marker_type_highlighted` : ``,
  ), [items.length, isHighlighted]);

  return createPortal(
    <div className={iconClassName} onClick={onClick}>
      <PropertyMarkerIcon items={items} />
    </div>,
    markerRef.current
  );
}

function PropertyMarkerIcon({
  items,
}) {
  if (items.length !== 1) return (
    <>
      <div className={`map-search__caption-icon`}><HouseIcon /></div>
      <div className={`map-search__caption-count`}>{items.length > 99 ? `+` : items.length}</div>
    </>
  );

  let property = items[0];

  if (!property.price) return `POA`;

  if (property.state === 'Sold') return `SOLD`;

  return (
    <>
      {shortPrice(property.price, property.currency)}{property.priceUnit === 'sqm' ? '/m²' : ''}
    </>
  );
}
